(function() {

    angular.module("conto")
        .constant('AppConfig', appConfig);

})();